import React from 'react';
import styles from '../StoreGuide.module.scss';
import SupportEmailLink from '../../../components/SupportEmailLink/SupportEmailLink';
import DiscordInviteButton from '../../../components/DiscordInviteButton/DiscordInviteButton';

const GOGGuide: React.FC = () => {
  return (
    <div className={styles.guideContent}>
      <div className={styles.guideHeader}>
        <img 
          src={`${process.env.PUBLIC_URL}/images/activation-guides/gog_dotcom2.png`}
          alt="GOG.com"
          className={styles.storeLogo}
          onError={(e) => {
            const target = e.currentTarget;
            target.onerror = null;
            target.style.display = 'none';
          }}
        />
        <div className={styles.storeTitle}>
          <h1>Product key activation on Gog.com</h1>
          <p>Activate your GOG.com keys through the website or GOG GALAXY application</p>
        </div>
      </div>

      <div className={styles.stepsContainer}>
        <div className={styles.steps}>
          
          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>1</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Access Redeem Page</h3>
              <div className={styles.stepDescription}>
                If you have a retail code, or purchased one from other authorized platform, access our{' '}
                <a 
                  href="https://www.gog.com/redeem" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={styles.inlineLink}
                >
                  redeem page
                </a>
                . OR in <strong className={styles.boldText}>GOG GALAXY</strong>, click the <strong className={styles.boldText}>cogwheel icon</strong> in the top left →<strong className={styles.boldText}>Add games & friends</strong> →<strong className={styles.boldText}>Redeem GOG code</strong>.
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>2</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Enter Code and Continue</h3>
              <div className={styles.stepDescription}>
                Once there, type in the code, click the checkbox next to <strong className={styles.boldText}>"I'm not a robot"</strong>, and click <strong className={styles.boldText}>"continue"</strong>. If all goes well, the game info will be displayed, and the game(s) will be added to your account once you click <strong className={styles.boldText}>"continue"</strong> again. Please keep in mind that the code will be "reserved" for you for a few minutes after you select it. To make it redeemable for others, click <strong className={styles.boldText}>"Cancel"</strong>.
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>3</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Troubleshooting</h3>
              <div className={styles.stepDescription}>
                If the code doesn't work, double-check if it was typed in correctly. Or if you purchased the code from an unauthorized key reseller, it is possible that the code was either blocked, or used by someone else before you.
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>4</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>OnePlay Support</h3>
              <div className={styles.stepDescription}>
                <div style={{ marginBottom: '12px' }}>
                  For any assistance please contact us via email at <SupportEmailLink /> or join our Discord channel:
                </div>
                <DiscordInviteButton />
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* <div className={styles.additionalNotes}>
        <h3>Important Notes</h3>
        <ul>
          <li>GOG codes are region-specific and must match your account region</li>
          <li>Codes can only be used once and cannot be transferred between accounts</li>
          <li>Make sure you purchase codes from authorized resellers only</li>
          <li>The code will be temporarily reserved after entering it</li>
        </ul>
      </div>

      <div className={styles.support}>
        <h3>Need More Help?</h3>
        <p>
          If you encounter any issues during the activation process, visit the official{' '}
          <a 
            href="https://support.gog.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.supportLink}
          >
            GOG Support Center
          </a>
          {' '}for additional assistance.
        </p>
      </div> */}
    </div>
  );
};

export default GOGGuide; 